<template>
  <div class="gg-chat-room">
    <chat-room
      ref="room"
      :room="room"
      :user="userData"
      :show-sidebar="showSidebar"
      :empty-message="emptyMessage || 'Spark up a conversation!'"
      @click="handleMessageClicked"
    >
      <template v-slot:message-user="{message}">
        <user-image :user-id="message.sender_id" />
      </template>
    </chat-room>
    <light-box
      v-if="image"
      :start-at="media.findIndex(m => m.src == image)"
      :media="media"
      @onClosed="image = null"
    />
  </div>
</template>

<script>
import LightBox from 'vue-image-lightbox';
import ChatRoom from '@virgodev/chat/components/ChatRoom.vue';
import UserImage from './UserImage.vue';

export default {
  name: 'GGChatRoom',
  components: {
    UserImage,
    ChatRoom,
    LightBox,
  },
  props: {
    room: { type: String, default: '__default__' },
    showSidebar: { type: Boolean, default: true },
    emptyMessage: { type: String, default: null },
  },
  data() {
    return {
      image: null,
    };
  },
  computed: {
    media() {
      return this.$refs.room.messages.filter(
        m => m.msg_type === 'image',
      ).map(
        m => ({ src: m.upload, thumb: m.upload }),
      );
    },
  },
  methods: {
    handleMessageClicked(msg) {
      if (msg.msg_type === 'image') {
        this.image = msg.upload;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 1024px) {
  #app .gg-chat-room /deep/ {
    .messages-sidebar {
      padding-top: 65px;
    }
  }
}
.gg-chat-room {
  flex-direction: row;
  overflow: hidden;
  place-self: stretch;
  flex: 1 1 auto;
  justify-content: stretch;
  align-items: stretch;
  display: flex;
}
.chat-room {
  flex: 1 1 auto;
}
.gg-chat-room /deep/ {

  .sidebar-close-button {
    text-align: right;

    a {
      padding: 12px;
      font-size: 13px;
      width: 25px;
      height: 25px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      color: white;
      background: var(--blue-light);
      border-radius: 40%;
    }
  }
  .messages-sidebar {
    flex: 0 0 auto;
    padding-top: 0;
    padding-right: 10px;
    margin-right: 10px;
    border-right: 1px solid rgba(0, 0, 0, 0.3);
  }
  .messages-column {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
  }
  .message-form {
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
  }
  .input-row {
    display: flex;
    flex-direction: row;
  }
  .messages {
    overflow-y: auto;
    flex: 1 1 auto;
  }
  .message {
    display: flex;
    flex-direction: row-reverse;
    margin: 10px;
  }
  .message.other {
    flex-direction: row;
  }

  .user-image {
    margin-top: 10px;
    flex: 0 0 auto;
  }
  .chat-bubble {
    flex: 1 1 auto;
    background: #416ed4;
    color: white;
    border-radius: 10px;
    margin-right: 16px;
    position: relative;
  }
  .other .chat-bubble {
    margin-left: 16px;
    margin-right: 0px;
    background: #3b88c2;
    // color: #333;
  }
  .chat-bubble:before {
    content: "";
    position: absolute;
    top: 25px;
    left: 100%;
    border: 7px solid transparent;
    border-top: 7px solid #416ed4;
    border-left: 7px solid #416ed4;
  }
  .other .chat-bubble:before {
    content: "";
    position: absolute;
    top: 25px;
    left: auto;
    right: 100%;
    border: 7px solid transparent;
    border-top: 7px solid #3b88c2;
    border-right: 7px solid #3b88c2;
  }
  .chat-bubble p {
    padding: 10px;
  }
  .chat-bubble .timestamp {
    position: absolute;
    bottom: 5px;
    right: 5px;
    font-size: 10px;
    opacity: 0.8;
  }
  .spacer {
    flex: 1 1 auto;
  }
  .text-muted {
    font-size: 12px;
  }
  form {
    position: relative;
    flex: 0 0 auto;
    margin-top: 5px;
    width: 100%;
    align-items: stretch;
    justify-content: stretch;
  }
  form input {
    margin-right: 5px;
    font-size: 15px;
    flex: 1 1 auto;
  }
  form button {
    font-size: 15px;
    flex: 0 0 auto;
  }
  .empty {
    flex: 10 10 auto;
    padding: 25px;
    text-align: center;
    background: white;
    border-radius: 15px;
    margin: 30px 60px;
  }
  .download {
    padding: 5px;
  }
  .alert.alert-error {
    margin: 0;
    background: var(--yellow-light);
    color: var(--red);
  }
  .user {
    font-size: 10px;
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .chat-bubble img {
    max-width: 250px;
    max-height: 250px;
    border-radius: 5px;
    margin: 5px;
    margin-bottom: -1px
  }
}
</style>
